import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { DialogRef } from 'angular2-modal';

import { SharedThirdPartyIntegrationService } from '../../../shared/services/shared-third-party-integration.service';


export class AtsConfigModalComponent implements OnInit {
	public state: any;
	public atsConfigType = 'requested_all';
	public mappedCandidatesCount: number = 0;

	constructor(public dialog: DialogRef<any>, private sharedThirdPartyIntegrationService: SharedThirdPartyIntegrationService) { }

	public ngOnInit(): void {
		if (this.dialog.context.activeIntegrationType) {
			this.atsConfigType = this.dialog.context.activeIntegrationType;
		}
		this.getTotalMappedCandidates();
	}

	public closeModal(): void {
		this.dialog.close(null);
	}

	public connect(): void {
		this.dialog.close(this.atsConfigType);
	}

	public atsConfigChange(type: string) {
		this.atsConfigType = type;
	}

	private getTotalMappedCandidates(): void {
		this.sharedThirdPartyIntegrationService.getMappedCandidatesCountByIntegration(this.dialog.context.activeIntegrationIdentifier).subscribe(
			(count) => {
				this.mappedCandidatesCount = count;
			}
		);
	}
static ctorParameters() { return [ { type: DialogRef }, { type: SharedThirdPartyIntegrationService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/settings/modals/ats-config-modal/ats-config-modal.component.ts